import { ADD_BOOKING, REMOVE_BOOKING } from "./actionTypes";

const initialState = {
  bookingList: [],
};

const bookingReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_BOOKING:
      return {
        ...state,
        bookingList: [...state.bookingList, action.payload],
      };
      
    case REMOVE_BOOKING:
      const { id } = action.payload;
      const updatedBookingList = state.bookingList.filter((booking, index) => index !== id);
      return {
        ...state,
        bookingList: updatedBookingList
      };

    default:
      return state;
  }
};

export default bookingReducer;
